<div [ngSwitch]="type" xmlns:div="http://www.w3.org/1999/html">

  <!-- Company Data Format -->
  <div *ngSwitchCase="'company-data'">
    <div *ngIf="shortContent !== null" class="company-data">
      <div class="text-md md:text-md text-secondary  dark:text-white font-semibold hover:opacity-90 cursor-pointer" (click)="readMore()">${{ shortContent }}</div>
    </div>
    <div *ngIf="shortContent === null" class="flex items-center mt-2">
      <!-- Just the spinner without text -->
      <span [ngClass]="['relative', 'flex', 'items-center', size]">
      <span [ngClass]="['animate-ping', 'absolute', 'inline-flex', 'rounded-full', size, 'bg-' + color, 'opacity-75']"></span>
      <span [ngClass]="['relative', 'inline-flex', 'rounded-full', size, 'bg-' + color]"></span>
    </span>
    </div>
  </div>

  <!-- Company News Format -->
  <div *ngSwitchCase="'company-news'">
    <div *ngIf="newsContent && newsContent.length > 0; else loading">
      <div *ngFor="let item of newsContent; let i = index" class="mb-6 last:mb-0 border-b border-blue-sky/10 dark:border-gray-700 pb-4 last:border-0 last:pb-0">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-sm font-medium !text-secondary dark:!text-primary-200">{{item.title}}</h3>
          <span class="text-xs text-gray-500 dark:text-gray-400 ml-2">{{item.date}}</span>
        </div>
        <p class="text-sm !text-secondary dark:!text-primary-200 mb-2">{{item.short_description}}</p>
        <div *ngIf="item.long_description" class="hidden">{{item.long_description}}</div>
        <div class="flex items-center mt-2">
          <a *ngIf="item.url" [href]="item.url" target="_blank" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90">
            Read more on website
          </a>
          <button *ngIf="item.long_description" type="button" (click)="readNewsItem(i)" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 ml-4">
            View details
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Exploratory Email Format -->
  <div *ngSwitchCase="'exploratory-email'">
    <div *ngIf="shortContent !== null; else loading">
      <p class="text-sm !text-secondary dark:!text-primary-200" [ngClass]="class">
        {{ shortContent }}
      </p>
      <ng-container *ngIf="showButton">

        <div class="absolute bottom-3 left-3">
          <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
            Email content
          </button>
          <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
            Email content
          </button>
        </div>

        <div class="absolute bottom-3 right-3">

          <button type="button" (click)="copyEmailContent(longContent)" class="text-blue-royal hover:opacity-90 transition-transform duration-300 hover:-rotate-6" matTooltip="Copy content" matTooltipPosition="left" matTooltipClass="blue-royal-tooltip">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
              <path fill-rule="evenodd" d="M13.887 3.182c.396.037.79.08 1.183.128C16.194 3.45 17 4.414 17 5.517V16.75A2.25 2.25 0 0 1 14.75 19h-9.5A2.25 2.25 0 0 1 3 16.75V5.517c0-1.103.806-2.068 1.93-2.207.393-.048.787-.09 1.183-.128A3.001 3.001 0 0 1 9 1h2c1.373 0 2.531.923 2.887 2.182ZM7.5 4A1.5 1.5 0 0 1 9 2.5h2A1.5 1.5 0 0 1 12.5 4v.5h-5V4Z" clip-rule="evenodd" />
            </svg>
          </button>

        </div>

      </ng-container>
    </div>
  </div>

  <!-- Role Format -->
  <div *ngSwitchCase="'role'" class="mb-8">
    <div *ngIf="listContent.length > 0; else loading">
      <h3 *ngIf="jobLevel !== 'Unknown job level'" class="text-md font-semibold mb-4">
        {{ company.person_name }}'s role is <span class="!text-violet-500">{{ jobLevel }}</span>
      </h3>
      <h3 *ngIf="jobLevel === 'Unknown job level'" class="text-md font-semibold mb-4">
        {{ company.person_name }}'s role could not be found.
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3 h-full">
        @for (item of listContent; track item; let i = $index) {
          <div class="flex flex-col items-center justify-start">
            <div
              class="bg-gray-100 dark:bg-secondary rounded-md p-4 mb-2 w-full"
              [class.bg-violet-500]="roleSelections[i]"
              [class.dark:bg-violet-500]="roleSelections[i]"
            ></div>
            <p class="text-sm font-medium !text-secondary dark:text-white tracking-wide"
               [class.font-semibold]="roleSelections[i]"  [class.dark:!text-primary-200]="roleSelections[i]">
              {{ item }}
            </p>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Role 2 Format -->
  <div *ngSwitchCase="'role-2'" class="-mb-2">
    <div *ngIf="jobLevel !== 'Unknown job level'" class="mb-8">
      <div *ngIf="identifiedInterests.length > 0; else loading">
        <div *ngFor="let item of identifiedInterests;" class="pills">
            <span class="flex items-center text-xs text-secondary-900">
                {{ item ?? ''}}
            </span>
        </div>
      </div>
    </div>
    <div *ngIf="jobLevel === 'Unknown job level'" class="mb-8">
      <p class="!text-secondary">N/A</p>
    </div>
  </div>

  <!-- Personal Background Format -->
  <div *ngSwitchCase="'personal-background'">
    <div *ngIf="shortContent !== null; else loading">
      <p class="text-sm !text-secondary dark:!text-primary-200" [ngClass]="class" [innerHTML]="shortContent"></p>
      <ng-container *ngIf="showButton">
        <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
          Read more
        </button>
        <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
          Long version
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Insights Format -->
  <div *ngSwitchCase="'insights'">
    <div *ngIf="shortContent !== null; else loading">
      <p class="text-sm !text-secondary dark:!text-primary-200" [ngClass]="class">
        {{ shortContent }}
      </p>
      <ng-container *ngIf="showButton">
        <div>
          <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
            Read more
          </button>
          <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="absolute bottom-3 left-3 btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
            Long version
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Basic Words Format -->
  <div *ngSwitchCase="'basic_words'">
    <div *ngIf="shortContent !== null; else loading">
      <p class="text-sm !text-secondary dark:!text-primary-200" [ngClass]="class">
        {{ shortContent }}
      </p>
      <ng-container *ngIf="showButton">
        <div>
          <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
            Read more
          </button>
          <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="absolute bottom-3 left-3 btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
            Long version
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- HTML Format -->
  <div *ngSwitchCase="'html'">
    <div *ngIf="htmlContent; else loading">
      <div [innerHTML]="htmlContent" class="text-sm font-light !text-secondary dark:!text-primary-200" [ngClass]="class"></div>
      <ng-container *ngIf="showButton">
        <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
          Read more
        </button>
        <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
          Long version
        </button>
      </ng-container>
    </div>
  </div>

  <!-- List Format -->
  <div *ngSwitchCase="'list'">
    <div *ngIf="listContent.length > 0; else loading">
      <ul class="list-disc font-light pl-5 text-secondary dark:!text-primary-200">
        <li *ngFor="let item of listContent" class="mb-2">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>

  <!-- Pills Format -->
  <div *ngSwitchCase="'pills'" class="-mb-2">
    <div *ngIf="listContent.length > 0; else loading">
      <div *ngFor="let item of listContent;" class="pills">
          <span class="flex items-center text-xs text-secondary-900 dark:!text-primary-200">
              {{ item ?? ''}}
          </span>
      </div>
    </div>
  </div>

  <!-- Years Format -->
  <div *ngSwitchCase="'years'">
    <div *ngIf="yearsContent !== null; else loading">
      <span class="text-xl !text-secondary dark:!text-primary-200 font-semibold">{{ yearsContent }}</span>
    </div>
  </div>

  <!-- Default Format -->
  <div *ngSwitchDefault>
    <div *ngIf="promptContent !== null; else loading" class="h-full">
      <div>
        <!--
        <h3 *ngIf="title" class="text-base font-semibold pb-4">{{ title }}</h3>
        -->
        <p class="!text-secondary dark:!text-primary-200" [ngClass]="class">
          {{ promptContent }}
        </p>
      </div>
      <ng-container *ngIf="showButton">
        <div class="absolute bottom-3 left-3">
          <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
            Read more
          </button>
          <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
            Long version
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Special Box Format -->
  <div *ngSwitchCase="'special-box'">
    <div *ngIf="htmlContent !== null; else loading">
      <p class="text-sm text-secondary dark:!text-primary-200" [ngClass]="class" [innerHTML]="htmlContent"></p>
      <ul *ngIf="specialContent" class="list-disc font-light pl-5 text-secondary dark:!text-primary-200 mt-4">
        <li *ngIf="specialContent.current_stage_of_the_fund" class="text-sm mb-2">Current stage of the fund: {{ specialContent.current_stage_of_the_fund }}</li>
        <li *ngIf="specialContent.investment_stages" class="text-sm mb-2">Investment stages: {{ specialContent.investment_stages }}</li>
        <li *ngIf="specialContent.summary_investment_thesis" class="text-sm mb-2">Summary investment thesis: {{ specialContent.summary_investment_thesis }}</li>
        <li *ngIf="specialContent.ticket_size" class="text-sm mb-2">Ticket size: {{ specialContent.ticket_size }}</li>
        <li *ngIf="specialContent.top_startups" class="text-sm">Top startups: {{ specialContent.top_startups }}</li>
      </ul>
      <ng-container *ngIf="showButton">
        <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
          Read more
        </button>
        <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
          Read more
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Email Sequence Format -->
  <div *ngSwitchCase="'email-sequence'">
    <div *ngIf="htmlContent !== null; else loading">
      <p class="text-sm text-secondary dark:!text-primary-200" [ngClass]="class" [innerHTML]="htmlContent"></p>
      <ng-container *ngIf="showButton">
        <button *ngIf="buttonType === 1" type="button" (click)="readMore()" class="text-xs font-normal cursor-pointer text-blue-500 dark:text-blue-300 hover:opacity-90 mt-2">
          View full sequence
        </button>
        <button *ngIf="buttonType === 2" type="button" (click)="readMore()" class="btn bg-blue-royal text-white text-xs font-normal py-2 px-4 mt-2">
          View full sequence
        </button>
      </ng-container>
    </div>
  </div>

</div>

<!-- Shared Loading Template -->
<ng-template #loading>
  <div class="flex items-center space-x-3">

    <!--
    <app-pulse-loading [size]="'size-2'" [color]="'blue-sky'></app-pulse-loading>
    <p class="text-sm text-secondary dark:text-white">Gathering data...</p>
    -->

    <div class="flex items-center space-x-3">
      <span [ngClass]="['relative', 'flex', 'items-center', size]">
        <span [ngClass]="['animate-ping', 'absolute', 'inline-flex', 'rounded-full', size, 'bg-' + color, 'opacity-75']"></span>
        <span [ngClass]="['relative', 'inline-flex', 'rounded-full', size, 'bg-' + color]"></span>
      </span>
      <p class="relative text-sm !text-secondary dark:text-white loading-text">
        <span class="animated-random-gradient-text">
          Gathering data<span class="animated-dots"></span>
        </span>
      </p>
    </div>

  </div>
</ng-template>
